<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div class="container2 mobmargin">
<div *ngIf="cart && cart.length>0;else No_itemscontent">
   <mat-card *ngFor="let item of cart | slice">
     <mat-card-content>
        <div class="row">
            <div class="col-3 text-center ">
                <img class="img-thumbnail"
                 src="https://passport.petcart.in/images/prodimgs{{imgpath['id'+item.sku]}}">
                 <div class="row" *ngIf="currentnotavailableproduct.length>0">
                    <div *ngFor="let i of currentnotavailableproduct ">
                        <div *ngIf="i.pid===item.product_id">
                            <p style="color:red; overflow-wrap:break-word" *ngIf="i.qty>0 && i.status == 1">
                                Currently we have only ({{i.qty}}) of this item in stock. So please modify the quantity and try
                                again.
                            </p>
                            <p style="color:red; overflow-wrap:break-word" *ngIf="i.qty == 0 || i.status == 0">
                                    Currently this product is out of stock . So please modify your cart and try again
                            </p>
                        </div>
                    </div>
                 </div>
            </div>
          <div class="col-9">
              <p style="font-family: open sans; color:#9b7544; font-weight:bold; font-size:1.6em;"><strong>{{ item.product_name }}</strong></p>
              <div class="row" >
                  <div class="col-md-3 col-sm-12 text-left">
                      <p  style="font-size:1.25em; font-family: open sans; color:#000 ">  MRP Rs. {{ item.mrp }}</p>
                  </div>

                  <div class="col-md-3 col-sm-12 text-left">
                      <p  style="font-size:1.25em; font-family: open sans; color:#000 "> Discount Rs. {{ item.discount }} </p>
                  </div>

                  <div class="col-md-3 col-sm-12 text-left" >
                      <p  style="font-size:1.25em; font-family: open sans; color:#000 ">Payable Rs. {{ item.payable }} </p>
                  </div>
                </div>
                <div class="row">

                    <div class="col-md-2 col-sm-12 text-center qtychange" style="padding: 0px; margin-left: 15px;">
                        <button class="qtybtn" (click)='myCartSubMethod(item.id,item.sku,item.product_id)'>
                            <mat-icon style="width: 5px; font-size:12px">remove</mat-icon>
                        </button>
                       <a style="font-size: 15px; margin-bottom: 2px"> {{ item.quantity }} </a>
                        <button class="qtybtn" (click)='myCartAddMethod(item.id,item.sku,item.product_id)'>
                            <mat-icon style="width: 5px; font-size:12px">add</mat-icon>
                        </button>

                    </div>

                </div>
                <div>
                    <div class="col-12 text-left" style="margin-left: -16px">
                        <button class="btn btn-success3 btn-block"  (click)='myCartRemoveMethod(item.id)'> Remove</button>
                    </div>
                  </div>
            </div>
          </div>
     </mat-card-content>
   </mat-card>

  <div class="row" style="margin-top:2%;margin-bottom: 1%">
      <div class="col-sm-6" style="margin-bottom: 15px; margin-top:15px">
              <button  class="btn btn-success2 btn-block"  routerLink="/store/home">Continue Shopping</button>
      </div>
      <div class="col-sm-6" style="margin-bottom: 15px; margin-top:15px">
              <button class="btn btn-secondary btn-block" (click)="finalCheck()">Proceed To Checkout</button>
          </div>

</div>

</div>
</div>
<div class="footer">
        <app-footer></app-footer>
    </div>
<ng-template #No_itemscontent>
  <div class="container" *ngIf="cart && cart.length == 0">
      <mat-card style="margin-top: 50px; margin-bottom: 140px">
        <div class="row">
          <div class="col-sm-6" text-center >
              <label style="color: #cb983f;font-size: 18px ">
                  Your Cart Is empty. You can add items into to your cart   </label>
          </div>
          <div class="col-sm-6" text-center >
              <button  class="btn btn-success2 btn-block"  routerLink="/store/home">Continue Shopping</button>
          </div>
        </div>

          </mat-card>
  </div>


</ng-template>
